import { formatDate } from '../../dateFormat';
import RegistrarSignature from './RegistrarSignature';

const DEFAULT_REGISTRAR_NAME = 'Dr. Kimberly Bogle Jubinville';

interface Props {
  /** Registrar name shown under the signature line. */
  registrarName?: string | null;
  /** Date the transcript was issued. Defaults to today. */
  issuedAt?: Date;
}

/**
 * Registrar signature block shown at the end of the official transcript record:
 * a signature line, the issue date, and the official-when-signed note.
 */
const TranscriptSignature = ({
  registrarName = DEFAULT_REGISTRAR_NAME,
  issuedAt,
}: Props) => (
  <div className="w-full flex flex-col gap-1 pt-8 print:break-inside-avoid">
    <RegistrarSignature className="h-14 w-auto object-contain object-left -mb-1" />
    <div className="w-64 max-w-full border-t border-foreground pt-1">
      <p className="text-sm font-semibold text-foreground">
        {registrarName ?? DEFAULT_REGISTRAR_NAME}
      </p>
      <p className="text-xs text-muted-foreground">Registrar</p>
    </div>
    <p className="text-xs text-muted-foreground mt-3">
      Issued On:{' '}
      <span className="font-medium text-foreground">
        {formatDate(issuedAt ?? new Date())}
      </span>
    </p>
    <p className="text-xs text-muted-foreground">
      This transcript is official when signed by the Registrar.
    </p>
  </div>
);

export default TranscriptSignature;
